<template>
    <v-app>
        <v-main>
            <v-container>
                <div class="row flex-row filters align-items-start">
                    <div class="col-12 col-md-3 col-lg-3 search-filter">
                        <v-text-field
                            label="SEARCH"
                            v-model="searchfilter"
                            append-icon="mdi-magnify"
                            clearable
                            color="#7ec13e"
                            @input="resetPage()"
                        >
                        </v-text-field>
                    </div>
                    <div class="col-12 col-md-3 col-lg">
                        <v-select
                            :items="types"
                            item-text="name"
                            item-value="type"
                            label="CONTENT TYPE"
                            v-model="selectedtypes"
                            clearable
                            attach
                            color="#7ec13e"
                            @input="resetPage()"
                        >
                        </v-select>
                    </div>
                    <div class="col-12 col-md-3 col-lg">
                        <v-select
                            :items="alltopics"
                            label="TOPIC"
                            v-model="topicfilter"
                            clearable
                            attach
                            color="#7ec13e"
                            @input="resetPage()"
                        >
                        </v-select>
                    </div>
                    <div class="col-12 col-md-3 col-lg">
                        <v-select
                            :items="software"
                            label="SOFTWARE"
                            v-model="softwarefilter"
                            clearable
                            attach
                            color="#7ec13e"
                            @input="resetPage()"
                        >
                        </v-select>
                    </div>
                </div>
                <div class="row mb-5">
                    <div
                        v-for="(post, index) in visibleposts"
                        :key="post.id"
                        :visible="index < numberposts"
                        class="col-12 col-md-6 col-lg-4 my-1"
                    >
                        <a
                            class="thumb-border d-block"
                            :href="post.link"
                            :alt="post.title"
                        >
                            <v-img
                                class="mb-5"
                                :aspect-ratio="16 / 9"
                                :width="width"
                                :src="
                                    post.featured_img_src ||
                                        'https://jmtconsulting.com/wp-content/uploads/2017/07/JMT-Blog.png'
                                "
                                :alt="post.title"
                            />
                            <div
                                class="pill text-uppercase py-2"
                                :class="'pill-' + post.type"
                            >
                                <i :class="'fal ' + typeIcon(post.type)"></i>
                                {{ typeTransform(post.type) }}
                            </div>
                            <span
                                class="resource-title h5 py-3"
                                :href="post.link"
                                v-html="post.title"
                            ></span>
                        </a>
                    </div>
                </div>
                <v-pagination
                    v-if="filteredposts.length > visibleposts.length"
                    class="my-5 py-5"
                    :length="Math.ceil(filteredposts.length / 9)"
                    :total-visible="7"
                    v-model.number="page"
                    @input="
                        $vuetify.goTo('.filters', { duration: 100, offset: 86 })
                    "
                    color="#7ec13e"
                >
                </v-pagination>
            </v-container>
        </v-main>
    </v-app>
</template>

<script>
import '/node_modules/vuetify/dist/vuetify.min.css'
const he = require('../node_modules/he/he.js')

export default {
    name: 'App',

    components: {},

    data: () => ({
        publicPath: process.env.BASE_URL,
        width: null,
        allposts: [],
        showposts: [],
        numberposts: 9,
        bottomlimit: 0,
        page: 1,
        types: [
            {
                type: 'blog',
                name: 'Blog',
            },
            {
                type: 'case-study',
                name: 'Case Studies',
            },
            {
                type: 'downloads',
                name: 'Educational Downloads',
            },
            {
                type: 'press-release',
                name: 'JMT News',
            },
            {
                type: 'video',
                name: 'Videos',
            },
        ],
        alltypes: ['blog', 'downloads', 'video', 'press-release', 'case-study'],
        software: [
            'Sage Intacct',
            'MIP Fund Accounting & Cloud',
            'Ace Cloud Hosting',
            'ADP',
            'AvidXchange',
            'Bill.com',
            'FloQast',
            'Nexonia',
            'Workforce Go!',
            'Vena',
        ],
        selectedtypes: undefined,
        searchfilter: undefined,
        topicfilter: undefined,
        softwarefilter: undefined,
    }),
    watch: {
        selectedtypes() {
            this.$router.push({
                path: this.$router.currentRoute.fullPath,
                query: { type: this.selectedtypes || undefined },
            })
        },
        topicfilter() {
            this.$router.push({
                path: this.$router.currentRoute.fullPath,
                query: { topic: this.topicfilter || undefined },
            })
        },
        softwarefilter() {
            this.$router.push({
                path: this.$router.currentRoute.fullPath,
                query: { software: this.softwarefilter || undefined },
            })
        },
        searchfilter(sf) {
            this.$router.push({
                path: this.$router.currentRoute.fullPath,
                query: { search: sf || undefined },
            })
        },
    },
    created() {
        async function getPosts() {
            const response = await fetch(
                'https://jmtconsulting.com/wp-json/custom/resources'
            )
            let posts = await response.json()
            return posts
        }
        getPosts().then(data => {
            data = data.sort(function(a, b) {
                return new Date(b.date) - new Date(a.date)
            })

            data.forEach(post => {
                post.cats = post.cats.map(cat => {
                    return he.decode(cat)
                })
            })

            this.allposts = data
        })
    },
    mounted() {
        let query = this.$route.query
        this.selectedtypes = query.type || undefined
        this.topicfilter = query.topic || undefined
        this.searchfilter = query.search || undefined
        this.softwarefilter = query.software || undefined
    },
    methods: {
        typeTransform(type) {
            switch (type) {
                case 'blog':
                    return 'blog'
                case 'video':
                    return 'video'
                case 'press-release':
                    return 'JMT news'
                case 'downloads':
                    return 'Download'
                case 'case-study':
                    return 'case study'
            }
        },
        typeIcon(type) {
            switch (type) {
                case 'blog':
                    return 'mdi mdi-file-document-outline'
                case 'video':
                    return 'mdi mdi-play-circle-outline'
                case 'press-release':
                    return 'mdi mdi-newspaper-variant-multiple-outline'
                case 'downloads':
                    return 'mdi mdi-cloud-download-outline'
                case 'case-study':
                    return 'mdi mdi-chart-areaspline'
            }
        },
        more() {
            this.numberposts += 9
        },
        less() {
            this.numberposts -= 9
        },
        resetPage() {
            this.page = 1
        },
    },
    computed: {
        filteredposts() {
            return this.allposts
                .filter(post => {
                    if (!this.selectedtypes) {
                        return true
                    }
                    return this.selectedtypes.includes(post.type)
                })

                .filter(post => {
                    if (!this.searchfilter) {
                        return true
                    }
                    if (
                        post.title
                            .toLowerCase()
                            .includes(this.searchfilter.toLowerCase()) ||
                        post.tags.some(tag =>
                            this.searchfilter
                                .toLowerCase()
                                .includes(tag.toLowerCase())
                        ) ||
                        post.excerpt
                            .toLowerCase()
                            .includes(this.searchfilter.toLowerCase())
                    )
                        return true
                })

                .filter(post => {
                    if (!this.softwarefilter) {
                        return true
                    }
                    if (this.softwarefilter === 'Sage Intacct') {
                        return (
                            // post.title.toLowerCase().includes('intacct') ||
                            post.tags.some(tag =>
                                tag.toLowerCase().includes('intacct')
                            )
                        )
                    }
                    if (this.softwarefilter === 'MIP Fund Accounting & Cloud') {
                        return (
                            // post.title
                            //     .toLowerCase()
                            //     .includes('mip' || 'abila') ||
                            post.tags.some(tag =>
                                tag.toLowerCase().includes('mip' || 'abila')
                            )
                        )
                    } else {
                        return (
                            // post.title
                            //     .toLowerCase()
                            //     .includes(this.softwarefilter.toLowerCase()) ||
                            post.tags.some(tag =>
                                this.softwarefilter
                                    .toLowerCase()
                                    .includes(tag.toLowerCase())
                            )
                        )
                    }
                })

                .filter(post => {
                    if (!this.topicfilter) {
                        return true
                    }
                    return post.cats.some(cat => cat === this.topicfilter)
                })
        },
        alltopics() {
            let cats = new Set()
            this.allposts.forEach(function(post) {
                post.cats.forEach(function(cat) {
                    let topic = cat
                    cats.add(topic)
                })
            })
            const topics = [...cats].sort((a, b) => {
                a = a.toLowerCase()
                b = b.toLowerCase()

                if (a == b) {
                    return 0
                }
                if (a < b) {
                    return -1
                }
            })
            return topics
        },

        visibleposts() {
            let maxposts = this.page * 9
            let minposts = maxposts - 9
            return this.filteredposts.filter((post, i) => {
                return i < maxposts && i >= minposts
            })
        },
    },
}
</script>
<style scoped>
.v-application {
    font-family: Avenir, Roboto, sans-serif;
}
.v-input input {
    max-height: 32px;
    background-color: #ffffff;
}
.v-label {
    z-index: 1;
    font-size: 0.9rem !important;
}
.thumb-border {
    padding: 1rem 1.5rem;
    border: 1px solid #e5e5e5;
    height: 100%;
    text-decoration: none;
}
.thumb-border:hover {
    background-color: #f5f5f5;
}
.resource-title {
    color: #666666;
    font-weight: 300;
    font-size: 17px;
    text-decoration: none;
}
.pill {
    font-weight: 400;
    font-size: 0.75em;
    letter-spacing: 0.5px;
}
.pill-blog {
    color: #7fc241;
}
.pill-downloads {
    color: #0b92aa;
}
.pill-case-study {
    color: orange;
}
.pill-press-release {
    color: purple;
}
.pill-video {
    color: #ee6352;
}
</style>
